import React, { useEffect } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import LabeledCounter from 'src/shared/components/forms/counter/LabeledCounter'
import FormSection from 'src/shared/components/forms/FormSection/FormSection'
import FormSectionRow from 'src/shared/components/forms/FormSectionRow/FormSectionRow'
import { ExtensionEstanciaValues } from '../../EstensionEstancia-types'
import { Habitacion } from 'src/gql/schema'
import { useConfig } from 'src/pages/venta-habitacion/hooks/useConfig'

const Personas = ({ habitacion, loading }: { habitacion?: Habitacion, loading?: boolean }) => {

    const {
        control,
        setValue
    } = useFormContext<ExtensionEstanciaValues>()

    const nochesExtra = useWatch({ control, name: 'principal.nochesExtraCount' })
    const horasExtra = useWatch({ control, name: 'principal.horasExtraCount' })
    const personasExtraDisabled = !nochesExtra && !horasExtra

    useEffect(() => {
        setValue("personas.count", habitacion?.ultima_renta?.numero_personas || 0)
    }, [habitacion])

    useEffect(() => {
        if (personasExtraDisabled) setValue("personas.extraCount", 0)
    }, [personasExtraDisabled])

    const { personas_extra } = useConfig()
    
    return (
        <FormSection title="Personas">
            <FormSectionRow >
                <Controller
                    control={control}
                    name='personas.count'
                    render={({ field: { onChange, value }, fieldState }) =>
                        <LabeledCounter
                            style={{width: 180}}
                            disable={loading}
                            rightLabel='Personas'
                            onClick={onChange}
                            value={value}
                            min={1}
                            max={habitacion?.tipo_habitacion?.personas_incluidas === null ? Infinity : (habitacion?.tipo_habitacion?.personas_incluidas || 0)}
                        />
                    }
                />
                <Controller
                    control={control}
                    name='personas.extraCount'
                    render={({ field: { onChange, value }, fieldState }) =>
                        <LabeledCounter
                            style={{width: 180}}
                            disable={loading || !personas_extra || personasExtraDisabled}
                            rightLabel='Personas extra'
                            errorHintText={habitacion?.tipo_habitacion?.personas_extra_max === null ? "" : ((
                                habitacion?.tipo_habitacion?.personas_extra_max || 0
                            )) < (value || 0) ? "Límite de personas extra superado, necesitarás PIN para vender" : ""}
                            onClick={onChange}
                            value={value}
                            min={0}
                        />
                    }
                />
            </FormSectionRow>
        </FormSection>
    )
}

export default Personas